import React, { Component } from 'react';
import { Layout, Menu, Avatar, Divider, Icon, Button } from 'antd';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import jwtDecode from 'jwt-decode';
import axios from 'axios';

const { Header } = Layout;
const { SubMenu }  = Menu;

import { Constant } from '../../config';
import { hideMenuDisplayAction, updateProfileDetailAction } from '../../store/actions/headerBar';
import { toggleDrawerMenuAction } from '../../store/actions/leftSideMenu';

import './HeaderBar.css'

class HeaderBar extends Component {
	state = {
		name: ""
	}

	componentWillMount() {
		if (!localStorage.getItem(Constant.SessionKey)) {
			return
		}

		this._setProfileDetail()
	}

	componentDidUpdate = async (prevProps, prevState) => {
		if (this.props.headerBarStore.menuDisplay !== prevProps.headerBarStore.menuDisplay){
			this._setProfileDetail()
		}
  }

	logout = async () =>{
		let opt = {
      url: Constant.ADMIN_LOGOUT_API,
      method: "POST",
      headers: {
        'Authorization': "Bearer "+localStorage.getItem(Constant.SessionKey),
        'Content-Type': 'application/x-www-form-urlencoded'
      },
    }
    let resp

    try {
      resp = await axios(opt)
    } catch(err) {
      resp = err.response
    }

    if (!resp.data) {
      console.log(resp)
    } else if (resp.data.error) {
    	console.log(resp.data.error)
    }

		localStorage.removeItem(Constant.SessionKey)
		localStorage.removeItem(Constant.MyNameKey)
		this.props.hideMenuDisplayAction()
		window.location.href = "/"
	}

	onClick = e => {
		const { key } = e

		switch (key) {
			case "logout":
				this.logout()
				return
			default:
		}
	}

	_setProfileDetail = () => {
		let d = {}
		try {
			d = jwtDecode(localStorage.getItem(Constant.SessionKey))
		} catch(err) {
			return
		}

		if (!d.exp || Date.now() >= d.exp * 1000)
			return

		this.props.updateProfileDetailAction({
			firstname: d.firstname,
			lastname: d.lastname,
			email: d.email,
		})
	}

	render() {
		let name = ""
		let nameAbb = ""

		if (this.props.headerBarStore.profileDetail) {
			const { firstname, lastname } = this.props.headerBarStore.profileDetail
			if (firstname) {
				name = firstname+" "+lastname

			if (name)
				nameAbb = name.charAt(0);
			}
		}

		return (
			<Header className="header">
				<img className="logo" src="data:image/svg+xml;base64,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" alt="Movider" />
				{name.length > 0 ? 
					// For Desktop
					<div style={{textAlign: 'right'}}>
						<Menu
							className="my-menu"
			        mode="horizontal"
			        style={{ lineHeight: '64px', textAlign: 'right' }}
			        onClick={(e)=>this.onClick(e)}
			      >
			      	<SubMenu key="profileBar"
			          title={
			            <span>
			              <Avatar>{nameAbb}</Avatar>
			              <Divider type="vertical" />
			              <span>{name}</span>
			            </span>
			          }
			        >
			        	<Menu.Item key="profile">
			        		<NavLink to="/me"><Icon type="profile" />ข้อมูลส่วนตัว</NavLink>
			          </Menu.Item>
			          <Menu.Item key="change-password">
			        		<NavLink to="/change-password"><Icon type="lock" />เปลี่ยนรหัสผ่าน</NavLink>
			          </Menu.Item>
			          <Menu.Item key="logout">
			          	<Icon type="logout" />ออกจากระบบ
			          </Menu.Item>
			        </SubMenu>
			      </Menu>

		      	<Button className="menu-mobile-btn" icon="menu" onClick={this.props.toggleDrawerMenuAction} />
		      </div>
				: 
					""
				}
			</Header>
		)
	}
}

const mapStateToProps = state => {
	return {
		headerBarStore: state.headerBar,
		leftSideMenuStore: state.leftSideMenu
	}
}

const mapDispatchToProps = dispatch => {
	return {
		hideMenuDisplayAction: () => dispatch(hideMenuDisplayAction()),
		updateProfileDetailAction: ({firstname, lastname, email}) => dispatch(updateProfileDetailAction({firstname, lastname, email})),
		toggleDrawerMenuAction: () => dispatch(toggleDrawerMenuAction())
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderBar)


// WEBPACK FOOTER //
// ./src/containers/HeaderBar/index.js